import { useParams } from 'react-router-dom';
import Breadcrumb from './Breadcrumb';
import SeminarDetailBox from '../Seminars/SeminarDetailBox';
import IvWhite from "../../assets/icons/IvoryList.svg";
import Image from '../ui/Image';
import SeminarDetailsLoading from '../loading/seminar-details';
import axios from 'axios';
import { useLanguage } from '../../store/language-context';
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from 'react-i18next';

const SeminarDetails = () => {
    const { URL } = useLanguage();
    const { id } = useParams();
    const { t } = useTranslation();

    const { data: seminar, error, isLoading } = useQuery({
        queryKey: ['seminar-details', id, URL],
        queryFn: async () => {
            const response = await axios.get(`${URL}/seminars/${id}`);
            if (response.status !== 200) throw new Error(t('custom.err'))
            return response.data?.data?.data ?? response.data?.data;
        },
        retry: 0,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    })

    document.title = `${seminar?.title || t('routes.seminar-details')} | ${t('routes.seminars')}`;

    if (isLoading) {
        return (
            <div className="px-20 py-2 max-lg:px-4">
                <SeminarDetailsLoading />
            </div>
        );
    };

    if (error) {
        return (
            <div className='h-dvh w-full flex justify-center items-center text-xl'>
                <p id='err'>{t('custom.no-data-page')}</p>
            </div>
        )
    };
    return (
        <>
            <Breadcrumb pages={[t('routes.seminars'), seminar?.title || t('routes.seminar-details')]} />
            <main className='px-20 py-2 max-lg:px-4'>
                <section className=' mb-4 rounded-md relative'>
                    <main className='px-8 max-lg:px-2 space-y-3'>
                        <section className='border p-2 rounded-md relative'>
                            <div className='relative flex justify-center'>
                                <Image src={seminar?.image_cover} alt={seminar?.title} className={'object-cover w-full h-80 filter rounded-md'} />
                                <div className='absolute w-full h-full top-0 bg-[var(--hidden-red)] z-10 rounded-md'></div>
                                <p className='bg-secondary-tw text-white flex justify-center items-center gap-2 rounded-lg absolute w-[32rem] -bottom-5 p-1 text-base z-20 max-lg:w-11/12 max-md:w-full'>
                                    <span>
                                        <img src={IvWhite} alt='ivory-icon' />
                                    </span>
                                    <span>
                                        {seminar?.title}
                                    </span>
                                </p>
                            </div>
                            {
                                seminar?.description &&
                                <p className='!text-start mt-4' dangerouslySetInnerHTML={{ __html: seminar?.description }} />
                            }
                        </section>
                        <section>
                            {
                                seminar?.details?.map((detail, i) => (
                                    detail?.coaches?.map((coach, j) => (
                                        <SeminarDetailBox
                                            key={`${i}-${j}`}
                                            details={detail}
                                            coach={coach}
                                            title={seminar?.title}
                                        />
                                    ))
                                ))
                            }
                        </section>
                    </main>
                </section>
            </main>
        </>
    )
};

export default SeminarDetails;